import React from "react";
import articles from "../data/articles.json";

const Articles = () => {
  return (
    <div>
      <main>
        <section className=" pt-5 mt-5 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mt-2">
                <div className="main_title">
                  <h2 className="h2 text-primary">Articles</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-secondary-light px-80 pb-5">
          <div className="container">
            <div className="row">
              {articles.map((article) => (
                <div
                  key={article.id}
                  className={`col-12 col-lg-6 mb-4${article.centered ? " mx-lg-auto" : ""}`}
                >
                  <div className="feature_box-shadow d-flex flex-column p-4 h-100">
                    <div className="w-100 mb-3">
                      <img
                        src={article.image}
                        alt={article.alt}
                        className="img-fluid w-100"
                      />
                    </div>
                    <div className="flex-grow-1 d-flex flex-column">
                      <h3 className="fs-18 text-primary fw-bold mb-3">
                        {article.title}
                      </h3>
                      {article.external ? (
                        <a
                          href={article.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary mt-auto align-self-start"
                        >
                          {article.buttonText}
                        </a>
                      ) : (
                        <a
                          href={article.href}
                          download
                          className="btn btn-primary mt-auto align-self-start"
                        >
                          {article.buttonText}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Articles;
